<template>
    <section class="cf-section">
        <h2 class="cf-section__title">{{$tc('pages.comments.commentsCounter', totalQuantity)}}</h2>
        <comments-form
            :post-id="postId"
            :user="user"
            :tags="tags"
            :options="options"
            :moderable="moderable"
            :status-active="statusActive"
            :status-moderation="statusModeration"
            :message-counter="messageCounter"
            class="cf-section__form"
            @success="unshiftItem"
        />
        <comments-items
            v-if="items.length > 0"
            :items="items"
            :post-id="postId"
            :user="user"
            :tags="tags"
            :options="options"
            :per-page="perPage"
            :depth="depth"
            :level="level"
            :moderable="moderable"
            :status-active="statusActive"
            :status-moderation="statusModeration"
            :activity="commentsActivity"
            :message-counter="messageCounter"
            @reaction="fetchCommentsActivity"
        />
        <comments-preloader
            v-if="loading"
        />
        <comments-button
            v-if="isShowMoreBtn"
            color="blue"
            gray
            block
            hover
            @click="fetchMoreComments"
        >
            {{$t('pages.comments.showMore')}}
        </comments-button>
    </section>
</template>

<script>
import CommentsForm from './CommentsForm'
import CommentsButton from "./CommentsButton"
import CommentsPreloader from "./CommentsPreloader"
import commentsBasePropsMixin from "./mixins/commentsBasePropsMixin"

export default {
    name: 'Comments',
    mixins: [commentsBasePropsMixin],
    components: {
        CommentsPreloader,
        CommentsButton,
        CommentsItems: () => import('./CommentsItems'),
        CommentsForm
    },
    computed: {
        isShowMoreBtn() {
            return !!this.pagination &&
                !!this.pagination.nextPage &&
                !this.loading
        }
    },
    data() {
        return {
            loading: true,
            items: [],
            pagination: null,
            totalQuantity: 0,
            commentsActivity: null
        }
    },
    async mounted() {
        await this.fetchComments()
        await this.fetchCommentsActivity()
    },
    methods: {
        async fetchComments() {
            this.loading = true

            const params = {
                postId: this.postId,
                parentId: null,
                perPage: this.perPage
            }

            if(this.moderable) {
                params.status = `${this.statusActive},${this.statusDeleted}`
            }

            try {
                const response = await this.$api.comments.getComments(params)

                if(response.data.success === 1) {
                    this.items = response.data.data
                    this.totalQuantity = response.data.totalQuantity
                    this.pagination = response.data.pagination
                } else {
                    this.$emit('error', response.data.message)
                }

            } catch (error) {
                this.$emit('error', error.response.data.message)
            } finally {
                this.loading = false
            }
        },
        async fetchMoreComments() {
            if(!this.pagination && this.pagination.nextPage) {
                return
            }

            this.loading = true

            const params = Object.assign({}, this.pagination.nextPage)

            if(this.moderable) {
                params.status = `${this.statusActive},${this.statusDeleted}`
            }

            try {
                const response = await this.$api.comments.getComments(params)

                if(response.data.success === 1) {
                    this.items = this.items.concat(response.data.data)
                    this.pagination = response.data.pagination
                } else {
                    this.$emit('error', response.data.message)
                }

            } catch (error) {
                this.$emit('error', error.response.data.message)
            } finally {
                this.loading = false
            }
        },
        async fetchCommentsActivity() {
            try {
                const response = await this.$api.comments.getCommentsActivity({
                    postId: this.postId,
                    userId: this.user.userId
                })

                this.commentsActivity = response.data.data

            } catch (error) {

            } finally {

            }
        },
        unshiftItem(item) {
            this.items.unshift(item)
            this.totalQuantity++
        }
    }
}
</script>
